import React from 'react';

import { UserAvatarLive } from '../common/UserAvatarLive';
import _ from 'lodash';
import {prettyDuration} from '../common/TimeUtils';
import dayjs from 'dayjs';
import { IconButton } from '../common/IconButton';
import Ansi from "ansi-to-react";
import JSONPreview from '../common/JSONPreview';


const stateRowClass = state => ({
  completed: 'bg-light',
  cancelled: 'bg-light-secondary translucent',
  starting: 'bg-light-warning',
  running: 'bg-light-success',
  failed: 'bg-light-danger',
})[state] || '';

const stateBadgeClass = state => ({
  completed: 'badge-primary',
  starting: 'badge-warning',
  running: 'badge-success',
  cancelled: 'badge-secondary',
  failed: 'badge-danger',
})[state] || '';

function ProgressData({ progressData }) {
  if(progressData) {
    let {total, count} = progressData;
    return <div className={'text-info small'}>
      <span className='badge badge-primary mr-2'>{`${Math.round(count/total*100)}%`}</span>
      <span className='text-secondary'>{`${count}/${total}`}</span>
    </div>;
  }
  return null;
}

export default function ScriptRunsTable({ runs, onCancel, onShowLog, onShowOutput, onRerun, onEditParams }) {
  return <table className={'table table-sm'}>
    <thead>
    <tr>
      <th className={'text-center'}>Who</th>
      <th className={'text-center'}>When</th>
      <th className={'text-center'}>State</th>
      <th className={'text-center'}></th>
      <th className={'text-center'} title={'Duration'}>Dur.</th>
      <th className={'text-right'}>Cost</th>
      <th>Script</th>
      <th></th>
      <th>Log</th>
      <th>Parameters and output</th>
    </tr>
    </thead>

    <tbody>
    {(runs || []).map(({_id, startTime, createdBy, script, parameters, state, cancelled, progressText, progressTextHistory, progressData, error, endTime, id, metadata, ... other}) => {
      if(cancelled)
        state = 'cancelled';

      return <tr className={stateRowClass(state)} key={id}>
        <td className={'text-center'}>{createdBy ? <UserAvatarLive user={createdBy}/> : 'Anon'}</td>

        <td className={'text-info small text-center'}>
          {dayjs(startTime).fromNow()}
        </td>

        <td className={'text-center'}>
          <span className={`badge ${stateBadgeClass(state)}`}>{state}</span>
          <ProgressData progressData={progressData}/>
        </td>

        <td className={'text-center'}>
          {
            ['starting', 'running'].includes(state)
              ?
              <IconButton icon={'cancel'} className={'p-0'} level={'danger'} onClick={() => onCancel(_id)}>Cancel script</IconButton>
              :
              null
          }
        </td>

        <td className={'text-center '}>
          {prettyDuration((endTime ? new Date(endTime) : new Date()) - new Date(startTime))}
        </td>

        <td className={`text-right small text-${metadata?.llmTotalCost > 0.1 ? 'danger' : 'secondary'} text-right pt-2`}>
          {metadata?.llmTotalCost ? `$${(Math.ceil(metadata.llmTotalCost*100)/100).toFixed(2)}` : null}
        </td>

        <td className={'monospace pt-2'}>{script}</td>

        <td>
          {state !== 'running' ? <IconButton icon={'play_circle'} level={'success'} onClick={() => onRerun(script, parameters)} title={'Rerun with same parameters'}></IconButton> : null }
        </td>

        <td>
          { (other.hasLog || state === 'running') ? <IconButton icon={'article'} onClick={() => onShowLog(_id)} title={'See log'}/> : null}

          { other.hasOutput ? <IconButton icon={'data_object'} onClick={() => onShowOutput(_id)}>Show output</IconButton> : null}
        </td>

        <td>
          <div className='d-flex'>
            { progressText ? <pre className={'bg-dark text-white rounded p-1 mr-2'} style={{width: '400px', fontSize: '10px', whiteSpace: 'pre', overflowX: 'scroll'}}>
                <Ansi>{(progressTextHistory || [progressText]).slice(-5).join('\n').split('\n').slice(-5).join('\n')}</Ansi>
              </pre> : null}
            <div className='flex-grow-1'>
              {_.isEmpty(parameters) ? null : <span className='d-inline-flex align-items-center'>
                <JSONPreview value={parameters}/>
                {onEditParams ? <IconButton icon={'edit'} className={'p-0 ml-1'} level={'primary'} style={{fontSize: '14px'}} onClick={() => onEditParams(script, parameters)} title={'Edit and re-run with these parameters'}/> : null}
              </span>}              

              {error ? <pre className={'small text-danger p-1 mb-0 text-wrap'}>{error}</pre> : null}

              {other?.length ? JSON.stringify(other) : null}
            </div>
          </div>

        </td>
      </tr>;
    })}
    </tbody>
  </table>;
}
